import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import './utils/i18n';
import './index.sass';
import { useTranslation } from 'react-i18next';
import Layout from './pages/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import NoPage from './pages/NoPage';
import Bakery from './pages/projects/Bakery';
import Ds from './pages/projects/Ds';
import Villa from './pages/projects/Villa';
import Soa from './pages/projects/Soa';
import Medic from './pages/projects/Medic';
import Cps from './pages/projects/Cps';
import Homeswitch from './pages/projects/Homeswitch';
import Brb from './pages/projects/Brb';
import Kucni from './pages/projects/Kucni';
import Scooter from './pages/projects/Scooter';
import Cs from './pages/projects/Cs';

export default function App() {
  const { i18n } = useTranslation();
  
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={`/${i18n.language}`} replace />} />
          <Route path="/:lng" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/:lng/about-me" element={<About />} />
            <Route path="/:lng/o-meni" element={<About />} />
            <Route path="/:lng/contact" element={<Contact />} />
            <Route path="/:lng/kontakt" element={<Contact />} />
            <Route path="/:lng/bakery-app" element={<Bakery />} />
            <Route path="/:lng/pekara-app" element={<Bakery />} />
            <Route path="/:lng/design-system" element={<Ds />} />
            <Route path="/:lng/dizajn-sistem" element={<Ds />} />
            <Route path="/:lng/little-villa" element={<Villa />} />
            <Route path="/:lng/villa-mala" element={<Villa />} />
            <Route path="/:lng/soa" element={<Soa />} />
            <Route path="/:lng/soa-hr" element={<Soa />} />
            <Route path="/:lng/medic-villa" element={<Medic />} />
            <Route path="/:lng/villa-medic" element={<Medic />} />
            <Route path="/:lng/cps" element={<Cps />} />
            <Route path="/:lng/cps-hr" element={<Cps />} />
            <Route path="/:lng/homeswitch" element={<Homeswitch />} />
            <Route path="/:lng/homeswitch-hr" element={<Homeswitch />} />
            <Route path="/:lng/boatrentalsbrac" element={<Brb />} />
            <Route path="/:lng/boatrentalsbrac-hr" element={<Brb />} />
            <Route path="/:lng/kucni-red" element={<Kucni />} />
            <Route path="/:lng/house-flow" element={<Kucni />} />
            <Route path="/:lng/st-skuter" element={<Scooter />} />
            <Route path="/:lng/st-scooter" element={<Scooter />} />
            <Route path="/:lng/croatiasoundworks" element={<Cs />} />
            <Route path="/:lng/croatiasoundworks-hr" element={<Cs />} />
            <Route path="/:lng/*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
